import { Dialog } from "@mui/material";

interface DeleteConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
}: DeleteConfirmationModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableScrollLock
      PaperProps={{
        sx: {
          borderRadius: "24px",
        },
      }}
    >
      <div className="rounded-[24px] px-8 py-6">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-medium text-neutral-700">
            Remove Discount
          </h2>
          <button onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#334155"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <hr className="mb-6 mt-4 border-t border-t-neutral-200 max-sm:mb-10 max-sm:mt-4" />

        <p className="mt-12 text-center text-lg text-text max-sm:text-base">
          Are you sure you want to delete this discount?
        </p>

        <div className="mt-12 flex items-end gap-5 max-sm:mt-10 max-sm:gap-2">
          <button
            onClick={onClose}
            className="h-10 w-1/2 rounded-[5px] bg-button-background text-[16px] font-medium text-neutral-950"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="h-10 w-1/2 rounded-lg bg-[#F75C5C] text-[16px] font-medium text-white"
          >
            Delete
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
